import { mdiCalendarCheckOutline } from '@mdi/js'

export default {
  title: 'Calendar',
  to: 'calendar',
  icon: mdiCalendarCheckOutline,
  resource: 'CalendarSchool',
  action: 'read',
}
